import Tracker from './Tracker';

const notesFilterTracker = new Tracker('notesFilter', {
	NOTES_FILTER_ACTIVE: 'notesFilterActive'
});

export default notesFilterTracker;
